import { NestedItemBasicInfo, NestedProjectExplorer } from '@tableau/nested-project-explorer';
import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { projectExplorerStyles } from '~src/common/react/components/ProjectExplorerStyles';

/** TEST IDS */
export const MESSAGE_TEST_ID = 'dialog-message';

const messageStyles: React.CSSProperties = { marginBottom: TabStyles.Spacing.LargeSpace, marginTop: '0px' };

export type MoveContentDialogBodyState = {
  selectedItem: NestedItemBasicInfo;
}

export type MoveContentDialogBodyProps = {
  prompt: string;
  targets: NestedProjectExplorer.Props | null;
}

export type MoveContentDialogProps = ReactActionDialogBodyProps<MoveContentDialogBodyProps, MoveContentDialogBodyState>;

export function MoveContentDialogBody(props: MoveContentDialogProps) {
  return <>
    <p data-tb-test-id={MESSAGE_TEST_ID} style={messageStyles}>
      {props.prompt}
    </p>
    <div style={projectExplorerStyles}>
      <NestedProjectExplorer
        topLevelDestinationStatus={props.targets.topLevelDestinationStatus}
        projects={props.targets.projects}
        onSelectedProjectChanged={
          (item: NestedItemBasicInfo | null) => props.updateDialogState({ selectedItem: item })
        } />
    </div>
  </>;
}
